import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

export const formatDate = (date?: string | Date | null, format = 'DD.MM.YYYY HH:mm') =>
  date ? dayjs(date).format(format) : '';
